import { message } from "antd";

/**
 * 复制文本到剪贴板
 * @param {string | undefined | null} textToCopy 要复制的文本
 * @param {string} typeLabel 文本类型标签，用于消息提示 (例如 "Request ID", "cURL 命令")
 * @returns {Promise<void>}
 */
export const handleCopyText = async (
  textToCopy: string | undefined | null,
  typeLabel: string = "文本"
): Promise<void> => {
  if (!textToCopy) {
    message.warning(`没有可复制的${typeLabel}`);
    return;
  }
  try {
    await navigator.clipboard.writeText(textToCopy);
    message.success("复制成功");
  } catch (error) {
    message.error(`复制${typeLabel}失败`);
    console.error("Clipboard copy failed:", error);
  }
}; 